import script from "./Authority.vue?vue&type=script&setup=true&lang=js"
export * from "./Authority.vue?vue&type=script&setup=true&lang=js"

import "./Authority.vue?vue&type=style&index=0&id=1fdc8d46&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fdc8d46"]])

export default __exports__